import { render, staticRenderFns } from "./AttrDetails.vue?vue&type=template&id=20e87c51&scoped=true"
import script from "./AttrDetails.vue?vue&type=script&lang=js"
export * from "./AttrDetails.vue?vue&type=script&lang=js"
import style0 from "./AttrDetails.vue?vue&type=style&index=0&id=20e87c51&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e87c51",
  null
  
)

export default component.exports